import axios from 'axios';
import {
  SearchByIdsPayload,
  SearchByIdsResult,
  GetSelectedContentResponse,
  PutSelectedContentRequest,
} from '@ilteducation/content-matching-types';
import qs from 'qs';
import store from '@/store';

const getHeaders = () => ({
  'Content-Type': 'application/json',
});

const contentMatchingApiUrl = process.env.VUE_APP_CONTENT_MATCHING_API_URL!;

export const searchByIds = async (
  content: string,
  contentItemType: 'ArticleV1' | 'BookPart',
): Promise<SearchByIdsResult> => {
  const params: SearchByIdsPayload = {
    ids: [content],
    contentItemType,
  };
  const queryString = qs.stringify(params, { arrayFormat: 'comma' });
  const url = `${contentMatchingApiUrl}/search?${queryString}`;

  const response = await axios.get(url, {
    headers: getHeaders(),
  });
  return response.data;
};

/**
 * Get black- and whitelisted content matches for a specific contentId.
 */
export const getSelectedContent = async (contentId: string): Promise<GetSelectedContentResponse> => {
  const url = `${contentMatchingApiUrl}/selection/${contentId}`;
  const response = await axios.get(url, {
    headers: getHeaders(),
  });
  return response.data;
};

export const putSelectedContent = async (payload: PutSelectedContentRequest) => {
  const url = `${contentMatchingApiUrl}/selection/${payload.contentId}`;
  store.commit('api/setLoading', true);
  try {
    const response = await axios.put(url, payload, {
      headers: getHeaders(),
    });
  } finally {
    store.commit('api/setLoading', false);
  }
};
